import { Invoiceable, InvoiceLine, Party, Invoice, Budget, DeliveryNote, Proforma } from "@/modules/facturae/domain/Invoiceable";
import { InvoiceEditorScreenData } from "@/modules/facturae/domain/InvoiceEditorScreenData";
import { Product } from "../domain/Product";
import { Configuration } from "../domain/Configuration";
import { Sequence } from "../domain/Sequence";

export class VueInvoiceEditorScreenData implements InvoiceEditorScreenData{
    invoice: Invoice|Budget|DeliveryNote|Proforma
    rectificative_invoice: Invoiceable
    excel_pop_up: boolean
    delete_all_lines_pop_up: boolean
    supplier_pop_up: boolean;
    customer_pop_up: boolean;
    file: File
    loading: boolean
    resolve_pop_up: Function 
    error_upload_file: boolean
    snackbar: Object
    reject_dialog: boolean
    reject_comment: string
    loading_reject: boolean
    paid_dialog: boolean;
    paid_loading: boolean;
    customers: Party[];
    products: Product[];
    showErrors: boolean;
    showErrorsDialog: boolean;
    configuration: Configuration;
    asyncJobState: string;
    asyncJobId: number;
    action: string;
    download_type: string;
    download_options: Object[];
    downloadPopup: boolean;
    download_loading: boolean;
    send_dialog: boolean;
    send_loading: boolean;
    senderOption: string;
    emailForm: Object;
    selectedSequence: Sequence;
    availableSequences: Sequence[];
    payment_options: Object[];

    constructor(){
        this.invoice = null
        this.rectificative_invoice = null
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.supplier_pop_up = false
        this.customer_pop_up = false
        this.loading = false
        this.file = null
        this.error_upload_file = null
        this.resolve_pop_up = null
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
          }
        this.reject_dialog = false
        this.reject_comment = ''
        this.loading_reject = false
        this.paid_dialog = false
        this.paid_loading = false
        this.customers = []
        this.products = []
        this.showErrors = false
        this.showErrorsDialog = false
        this.configuration = new Configuration()
        this.asyncJobState = 'done';
        this.asyncJobId = 0;
        this.action = '';
        this.download_type = ''
        this.download_options = [
            {value: 'xml', text: 'XML'},
            {value: 'pdf', text: 'PDF'},
        ]
        this.downloadPopup = false
        this.download_loading = false;
        this.send_dialog = false;
        this.send_loading = false;
        this.senderOption = '';
        this.emailForm = {
            to: '',
            subject: '',
            body: ''
        }
        this.selectedSequence = new Sequence()
        this.availableSequences = []
        this.payment_options =  [
            { value: '00', text: '' },
            { value: '01', text: 'Al contado' },
            { value: '02', text: 'Recibo Domiciliado' },
            { value: '03', text: 'Recibo' },
            { value: '04', text: 'Transferencia' },
            { value: '05', text: 'Letra Aceptada' },
            { value: '06', text: 'Crédito Documentario' },
            { value: '07', text: 'Contrato Adjudicación' },
            { value: '08', text: 'Letra de cambio' },
            { value: '09', text: 'Pagaré a la Orden' },
            { value: '10', text: 'Pagaré No a la Orden' },
            { value: '11', text: 'Cheque' },
            { value: '12', text: 'Reposición' },
            { value: '13', text: 'Especiales' },
            { value: '14', text: 'Compensación' },
            { value: '15', text: 'Giro postal' },
            { value: '16', text: 'Cheque conformado' },
            { value: '17', text: 'Cheque bancario' },
            { value: '18', text: 'Pago contra reembolso' },
            { value: '19', text: 'Pago mediante tarjeta' }
        ]
    }

    success_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    async ask_for_file(){
      this.excel_pop_up = true
      return new Promise((resolve,reject)=>{
            this.resolve_pop_up = resolve
        })
    }

    async delete_all_lines_dialog(){
        this.delete_all_lines_pop_up = true
        return new Promise((resolve,reject)=>{
            this.resolve_pop_up = resolve
        })
    }

    confirm_pop_up(){
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.resolve_pop_up(true)
    }

    cancel_pop_up(){
        this.excel_pop_up = false
        this.delete_all_lines_pop_up = false
        this.resolve_pop_up(false)
    }

    setLoading(loading){
        this.loading = loading
    }

    setLines(lines){
        console.log('setting lines')
        this.invoice.lines = [...lines]
    }

    setInvoice(invoice){
        invoice.compute()
        this.invoice = invoice
        this.setLines(invoice.lines)
        this.computeDownloadOptions()
    }

    computeDownloadOptions(){
        if (['budget', 'delivery_note', 'proforma'].includes(this.invoice.type)) {
            this.download_options = [
                {value: 'pdf', text: 'PDF'},
            ]
        }
    }

    setRectificativeInvoice(invoice){
        if (invoice){
            invoice.compute()
            this.rectificative_invoice = invoice
        }
    }

    resetLines(){
        console.log('resetting lines')
        this.invoice.lines=[...this.invoice.lines]
    }

    setRejectDialog(reject_dialog: boolean): void {
        this.reject_dialog = reject_dialog
    }

    setLoadingReject(loading: boolean): void {
        this.loading_reject = loading
    }

    setPaidDialog(paid_dialog: boolean): void {
        this.paid_dialog = paid_dialog
    }

    setLoadingPaid(loading: boolean): void {
        this.paid_loading = loading
    }

    setCustomers(customers: Party[]): void {
        this.customers = customers
    }

    setCustomer(customer:Party): void {
        this.invoice.customer = customer
    }

    setProducts(products:Product[]): void {
        this.products = products;
    }

    setErrorDialog(showErrorsDialog: boolean): void {
        this.showErrorsDialog = showErrorsDialog
    }

    setSequence(sequence: Sequence): void {
        this.selectedSequence = sequence
    }

    setSequences(sequences: Sequence[]): void {
        this.availableSequences = sequences
    }

    setConfiguration(configuration: Configuration, is_from_recurring_contract?:boolean): void {
        this.configuration = configuration
        if (is_from_recurring_contract) {
            let recurringSeq = configuration.sequences.filter(sequence => sequence.is_for_recurring_contracts)
            this.setSequences(recurringSeq)
            return
        }
        let filteredSequences = configuration.sequences.filter(sequence => !sequence.is_for_recurring_contracts)
        this.setSequences(filteredSequences)
    }
}